<mat-accordion class="mat-expansion-panel-details">
    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" [expanded]="isPanelOpen()" (click)="generateTagIfOpen()" dataqsi="detailSteps">
        <mat-expansion-panel-header>
            <div class="title"> {{titleBloc | translate}} </div>
        </mat-expansion-panel-header>
        <div *ngFor="let item of list; let lastItem = last; let firstItem = first;">
            <div class="one_line">
                <div class="bubble_container">
                    <div [ngClass]="(!firstItem)?'top_line':'no_top_line'"></div>
                    <div class="bubble"></div>
                    <div [ngClass]="(!lastItem)?'bottom_line':'no_bottom_line'"></div>
                </div>
                <div class="content" [ngStyle]="!lastItem ? {'border-bottom': '1px solid #DCDEDC'} : {'padding-bottom':'1vh'}">
                    <div class="label_container">{{item.label}}</div>
                    <div class="complementary_informations">
                        <div class="date_container">
                            {{item.date}}
                        </div>
                        <div class="location_container" *ngIf="item.group.substring(0, 3) !== 'EXP'">
                            <div class="locationText" *ngIf="item.location !== 'REPONSE WEB'">
                                {{item.location}},
                            </div>
                            <div class="locationText" style="text-indent: 2px;">
                                {{item.zipCode}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
